export function getImgUrl(url) {
    return process.env.VUE_APP_IMG_URL + url
}

// todo vdom/dom 的观察者模式监听服务于视图层而非数据层
// todo 在vue中因为采取了Vdom结构通过数据影响视图
// todo 所以处只参与CSS in JS 和 CSS 动画效果不多此一举控制DOM

// IntersectionObserver对象
export const $io = new IntersectionObserver(ioes => {
    ioes.forEach(ioe => {
        const el = ioe.target
        const intersectionRatio = ioe.intersectionRatio
        if (intersectionRatio > 0 && intersectionRatio <= 1) {
            // 实现懒加载(可配合vue指令,v2不写)
            if (el.dataset.src) el.src = el.dataset.src;
            // 实现Animate动画
            if (el.dataset.class) el.classList.add(el.dataset.class);
            // io.unobserve(el)  
            // 停止观察当前元素 避免不可见时候再次调用callback函数 ()
        }
        el.onload = el.onerror = () => io.unobserve(el)
    })
})


// todo 后续使用`MutationObserver`配合IntersectionObserver对象 
// todo 监视DOM树完成改变后是否操作进行下一步操作，保证非vue双向绑定数据的页面也可监听DOM树
//? https://developer.mozilla.org/zh-CN/docs/Web/API/MutationObserver
//!  拆分避免New产生的内存得不到销毁

const observercallback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            console.log('A child node has been added or removed.');
            return 'childList';
        } else if (mutation.type === 'attributes') {
            // 此处适合`el.src = el.dataset.src;`的二段操作，先`ob`再`io`
            // * mutation.attributeName eg:src,class
            console.log('The ' + mutation.attributeName + ' attribute was modified.');
            // return {
            //     'attributes': mutation.attributeName
            // }
            return 'attributes';
        } else if (mutation.type === 'subtree') {
            return 'subtree';
        }
    }
};
/**  
 * @author Nidhogg·D·Joking
 * @version v0.0.1
 * @param targetNode eg: document.getElementById('app');
 * @param config observerOptions = {
 *       childList: true,  // 观察目标子节点的变化，是否有添加或者删除
 *       attributes: true, // 观察属性变动
 *       subtree: true     // 观察后代节点，默认为 false
 * }
 * @return String
 */
const observer = new MutationObserver(observercallback);
export function $ob(targetNode, config = {
    attributes: true,
    childList: true,
    subtree: true
}) {
    return observer.observe(targetNode, config);
}


//? 采取CDN和线上双模式异步加载
export function loadSwiper() {
    return new Promise(function (resolve, reject) {
        if (typeof Swiper !== 'undefined') {
            resolve(Swiper)
            return true
        }
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.2/js/swiper.js'
        script.onerror = reject
        document.head.appendChild(script)
    })
}